import { format, parseISO } from "date-fns";

// Cents -> formatted currency string. Centralised so Inbox, ExpensesHub and
// ExpenseDetail all render amounts identically.
export function formatAmountCents(
  cents: number,
  currency = "USD",
  locale = "en-US",
): string {
  const formatter = new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
  });
  return formatter.format(cents / 100);
}

// ISO date (YYYY-MM-DD or full ISO) -> human-readable.
// Falls back to the raw string if the value can't be parsed so we don't crash
// on malformed data.
export function formatIsoDate(iso: string, pattern = "MMM d, yyyy"): string {
  try {
    return format(parseISO(iso), pattern);
  } catch {
    return iso;
  }
}
